export const CardConnectProviderUid = '6A641372-6527-4D9D-AC94-776F483179A0'.toLowerCase()

export const UsaePayProviderUid = '67C4CB8A-373B-4BD3-9D28-51C8A3A7411E'.toLowerCase()